import React from "react";
import { LuUpload } from "react-icons/lu";

const UploadButton = ({ label = "Upload" }) => {
  return (
    <button
      type="submit"
      aria-label={label}
      className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-teal-500 to-cyan-500 px-6 sm:px-14 font-semibold text-white shadow-lg shadow-teal-500/30 transition-all duration-200 hover:shadow-teal-500/50 hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-teal-400/50"
    >
      <LuUpload size={18} />
      {label}
    </button>
  );
};

export default UploadButton;
